import React from "react";
import s from './index.module.less'
import Avatar from "@/componentsNew/Avatar/index";
import { type VipType, VIP_TYPE_MAP } from '@/consts/newConsts'

const TAB = {
  VIP: 'vip',
  POWER: 'power',
};

interface VipHeaderProps {
  userInfo: any
  activeTab: string
  onSwitchTab: (tab: string) => void
  packageItem?: any
  hideRechargeButton?: boolean
}

const vipHeader = ({ userInfo, activeTab, onSwitchTab, packageItem, hideRechargeButton = false } : VipHeaderProps) => {
  const isVipActive = activeTab === TAB.VIP;

  const renderVipInfo = () => {
    // 根据选中的套包会员等级(type)，展示对应拥有的会员到期时长
    const vipType = packageItem?.type
    const vipInfoItem = (userInfo?.vip_info || []).find((item: any) => item.vip_type === vipType)
    if (vipInfoItem?.is_vip) {
      const vipName = VIP_TYPE_MAP[vipType as VipType]
      return (
        <span className="vipText">
          当前拥有{vipName}<span className="vipNum">{vipInfoItem.vip_remainder_days}</span>天
        </span>
      );
    }
    // 无该会员则不展示
    return null;
  };

  const renderTopsInfo = () => (
    <span className="vipText">
      当前拥有充值算力余额：<span className="vipNum">{userInfo?.total_tops || 0}</span>点
    </span>
  );

  return (
    <div className={s.header}>
      <div className="userBox">
        <Avatar size={50}/>
        <div className="userInfo">
          <span className="userName">{userInfo?.nickname}</span>
          <span className="userID">ID: {userInfo?.user_id}</span>
        </div>
        <div className="vipInfo">
          {isVipActive ? renderVipInfo() : renderTopsInfo()}
        </div>
      </div>
      {!hideRechargeButton && (
        <div className="rechargeBox">
          <div className={`rechargeBtn${isVipActive ? ' rechargePowerBtn' : ''}`} onClick={() => onSwitchTab(isVipActive ? TAB.POWER : TAB.VIP)}>
            {isVipActive ? '充值算力' : '开通会员'}
          </div>
        </div>
      )}
    </div>
  );
};

export default vipHeader;
